<script setup lang="ts">
import { useId } from "vue";
import AppIcon from "./AppIcon.vue";
import { usePreferencesStore, type ThemePreference } from "@/stores/preferences";
import { useI18n } from "@/i18n";
defineProps<{ compact?: boolean }>();
const preferences = usePreferencesStore();
const groupId = useId();
const { t } = useI18n();
const options: { value: ThemePreference; label: string; icon: string }[] = [
  { value: "system", label: "System", icon: "monitor" },
  { value: "light", label: "Light", icon: "sun" },
  { value: "dark", label: "Dark", icon: "moon" },
];
</script>

<template>
  <fieldset class="appearance-picker" :class="{ compact }">
    <legend class="sr-only">{{ t('Appearance') }}</legend>
    <label v-for="option in options" :key="option.value" :class="{ active: preferences.theme === option.value }" :title="t(option.value === 'system' ? 'Follow system appearance' : option.value === 'light' ? 'Light appearance' : 'Dark appearance')">
      <input v-model="preferences.theme" type="radio" :name="groupId" :value="option.value" :aria-label="t(option.label)" />
      <span v-if="!compact" class="theme-preview" :class="option.value" aria-hidden="true"><i /><span><b /><b /><b /></span></span>
      <span class="theme-label"><AppIcon :name="option.icon" :size="18" /><span>{{ t(option.label) }}</span><AppIcon v-if="!compact && preferences.theme === option.value" name="check" :size="16" /></span>
    </label>
  </fieldset>
</template>
